import moment from "moment-timezone";

import {
  DEFAULT_DATE_FORMAT_TIMEZONE,
  DEFAULT_DATE_TIMEZONE,
} from "./constants";

const createdDate = (val = "") => {
  const dt = moment.tz(
    val,
    DEFAULT_DATE_FORMAT_TIMEZONE,
    DEFAULT_DATE_TIMEZONE
  );
  if (!dt.isValid()) {
    return val;
  }
  return dt.format(DEFAULT_DATE_FORMAT_TIMEZONE);
};

export default { createdDate };
